
import { AddCounselorsComponent } from './practice-counselor/add-counselors/add-counselors.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { PracticeInformationComponent } from './practice-information/practice-information.component';
import { CounselorsComponent } from './practice-counselor/counselors/counselors.component';
import { CounselorResolverService } from './resolver/counselor-resolver.service';
import { HomeComponent } from './locations/home/home.component';
import { ProviderSitesComponent } from './locations/provider-sites/provider-sites.component';
import { BillingAddressComponent } from './locations/billing-address/billing-address.component';
import { LocationResolverService } from './resolver/location-resolver.service';
import { AddComponent } from './locations/provider-sites/add/add.component';
import { MailingAddressComponent } from './locations/mailing-address/mailing-address.component';
import { PracticeInformationResolverService } from './resolver/practice-information-resolver.service';




const routes: Routes = [
  { path: '', component: LandingComponent, data: { activeClass: "manage-practice" } },

  { path: 'locations', component: HomeComponent, data: { activeClass: "manage-practice" } },
  { path: 'locations/mailingaddress', component: MailingAddressComponent, data: {addressType:1, activeClass: "manage-practice" } ,resolve: { address: LocationResolverService }},
  { path: 'locations/billingaddress', component: BillingAddressComponent, data: {addressType:2, activeClass: "manage-practice" },resolve: { address: LocationResolverService } },
  { path: 'locations/providersites', component: ProviderSitesComponent, data: {siteList:true, activeClass: "manage-practice" }, resolve: { providerSites: LocationResolverService } },
  { path: 'locations/providersites/add', component: AddComponent, data: { activeClass: "manage-practice" } },
  { path: 'locations/providersites/edit/:id', component: AddComponent, data: {editSite:true, activeClass: "manage-practice" }, resolve: { providerSite: LocationResolverService } },
  { path: 'counselors', component: CounselorsComponent, data: {counselorList:true, activeClass: "manage-practice" } ,resolve: { counselors: CounselorResolverService }},
  { path: 'counselors/add', component: AddCounselorsComponent,  data: { editCounselor:true,activeClass: "manage-practice" }, resolve: { counselor: CounselorResolverService } },
  { path: 'counselors/edit/:id', component: AddCounselorsComponent, data: { editCounselor:true,activeClass: "manage-practice" }, resolve: { counselor: CounselorResolverService } },
  { path: 'practiceinformation', component: PracticeInformationComponent, data: { activeClass: "manage-practice" },resolve:{practiceInformation:PracticeInformationResolverService }},
  { path: 'licenseandliability', loadChildren: () => import('./license-liability/license-liability.module').then(m => m.LicenseLiabilityModule) }
    
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagePracticeRoutingModule { }
